var _rect, _text, _rect2, _text2, _path, _path2, _text3, _path3, _path4, _text4, _ellipse, _text5, _path5, _path6, _text6, _path7, _path8, _text7, _path9, _path10, _text8, _path11, _path12, _text9, _ellipse2, _text10, _ellipse3, _text11, _path13, _path14, _text12, _path15, _path16, _text13, _ellipse4, _text14, _path17, _path18, _text15, _path19, _path20, _text16, _ellipse5, _text17, _rect3, _path21, _text18, _path22, _path23, _text19, _path24, _path25, _text20, _ellipse6, _text21, _path26, _path27, _text22, _ellipse7, _text23, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3SourceOneTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1297px",
    height: "482px",
    viewBox: "-0.5 -0.5 1297 482",
    content: "<mxfile host=\"Electron\" modified=\"2023-06-25T02:43:16.253Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/20.3.0 Chrome/104.0.5112.114 Electron/20.1.3 Safari/537.36\" version=\"20.3.0\" etag=\"tVeZLf_D-8ekwb6x8hfL\" type=\"device\"><diagram id=\"W8vWeNJQh6JbM612qfxP\">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</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-60a337-1-277116-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(39, 113, 22)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(96, 163, 55)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-ff4f8b-1-bc1356-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(188, 19, 86)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(255, 79, 139)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-f78e04-1-d05c17-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(208, 92, 23)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(247, 142, 4)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "0%",
    y2: "0%",
    id: "mx-gradient-945df2-1-5a30b5-1-s-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "rgb(90, 48, 181)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "rgb(148, 93, 242)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 80,
    width: 350,
    height: 250,
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeDasharray: "3 3",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-end",
      justifyContent: "unsafe center",
      width: 348,
      height: 1,
      paddingTop: 327,
      marginLeft: 2
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "Customer ownership")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 176,
    y: 327,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Customer ownership")))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 474,
    y: 80,
    width: 821.5,
    height: 400,
    fill: "none",
    stroke: "#ff9933",
    strokeWidth: 2,
    strokeDasharray: "6 6",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-end",
      justifyContent: "unsafe center",
      width: 820,
      height: 1,
      paddingTop: 477,
      marginLeft: 475
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #FF9933; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(255, 153, 51)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "CLO ownership")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 885,
    y: 477,
    fill: "#FF9933",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "CLO ownership")))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 240.5 180 L 318.5 180 L 318.5 258 L 240.5 258 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 302.78 222.22 L 303.21 219.21 C 307.16 221.57 307.21 222.55 307.21 222.58 C 307.2 222.58 306.53 223.14 302.78 222.22 Z M 300.62 221.62 C 293.8 219.56 284.3 215.2 280.46 213.39 C 280.46 213.37 280.46 213.36 280.46 213.34 C 280.46 211.86 279.26 210.66 277.78 210.66 C 276.31 210.66 275.11 211.86 275.11 213.34 C 275.11 214.82 276.31 216.02 277.78 216.02 C 278.43 216.02 279.02 215.78 279.48 215.39 C 284.01 217.53 293.43 221.82 300.3 223.85 L 297.58 243.03 C 297.57 243.08 297.57 243.13 297.57 243.18 C 297.57 244.87 290.1 247.97 277.89 247.97 C 265.55 247.97 257.99 244.87 257.99 243.18 C 257.99 243.13 257.99 243.08 257.98 243.03 L 252.31 201.57 C 257.22 204.95 267.79 206.74 277.89 206.74 C 287.98 206.74 298.53 204.96 303.46 201.59 Z M 251.71 197.25 C 251.79 195.78 260.21 190.03 277.89 190.03 C 295.57 190.03 304 195.78 304.08 197.25 L 304.08 197.75 C 303.11 201.04 292.19 204.51 277.89 204.51 C 263.57 204.51 252.65 201.02 251.71 197.73 Z M 306.31 197.27 C 306.31 193.41 295.24 187.8 277.89 187.8 C 260.55 187.8 249.48 193.41 249.48 197.27 L 249.58 198.11 L 255.77 243.27 C 255.91 248.32 269.38 250.2 277.89 250.2 C 288.44 250.2 299.65 247.77 299.8 243.27 L 302.47 224.44 C 303.95 224.8 305.18 224.98 306.16 224.98 C 307.48 224.98 308.37 224.66 308.91 224.01 C 309.35 223.49 309.52 222.85 309.39 222.16 C 309.11 220.62 307.27 218.96 303.55 216.83 L 306.19 198.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 280
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon S3", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 13
    }
  }), "(Log bucket)")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 278,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Amazon S3...")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 120.5 218.86 L 214.13 218.86",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 219.38 218.86 L 212.38 222.36 L 214.13 218.86 L 212.38 215.36 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 235,
      marginLeft: 171
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Output")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 239,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Output")))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.5,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 157
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "1"))))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 171,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "1")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 685.5 180 L 763.5 180 L 763.5 258 L 685.5 258 Z",
    fill: "url(#mx-gradient-ff4f8b-1-bc1356-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 712.16 223.03 L 715.45 219.79 C 715.65 219.59 715.77 219.31 715.77 219.02 C 715.77 218.73 715.65 218.46 715.45 218.25 L 712.17 214.97 L 710.62 216.5 L 712.02 217.91 L 707.02 217.91 L 707.02 220.09 L 712.04 220.09 L 710.62 221.49 Z M 737.21 223.13 L 741.59 219.87 C 741.86 219.66 742.03 219.34 742.03 219 C 742.03 218.66 741.86 218.33 741.59 218.13 L 737.21 214.87 L 735.9 216.61 L 737.65 217.91 L 733.27 217.91 L 733.27 220.09 L 737.65 220.09 L 735.9 221.39 Z M 719.26 219 C 719.26 221.31 718.86 223.48 718.12 225.38 C 720.08 224.62 722.3 224.24 724.52 224.24 C 726.74 224.24 728.96 224.62 730.93 225.38 C 730.18 223.48 729.78 221.31 729.78 219 C 729.78 216.69 730.18 214.52 730.93 212.62 C 726.99 214.13 722.05 214.13 718.12 212.62 C 718.86 214.52 719.26 216.69 719.26 219 Z M 713.9 229.55 C 713.69 229.34 713.58 229.06 713.58 228.78 C 713.58 228.51 713.69 228.23 713.9 228.01 C 715.89 226.04 717.07 222.67 717.07 219 C 717.07 215.33 715.89 211.96 713.9 209.99 C 713.69 209.77 713.58 209.49 713.58 209.22 C 713.58 208.94 713.69 208.66 713.9 208.45 C 714.33 208.02 715.02 208.02 715.45 208.45 C 719.69 212.66 729.35 212.66 733.59 208.45 C 734.02 208.02 734.71 208.02 735.14 208.45 C 735.35 208.66 735.46 208.94 735.46 209.22 C 735.46 209.49 735.35 209.77 735.14 209.99 C 733.15 211.96 731.97 215.33 731.97 219 C 731.97 222.67 733.15 226.04 735.14 228.01 C 735.35 228.23 735.46 228.51 735.46 228.78 C 735.46 229.06 735.35 229.34 735.14 229.55 C 734.93 229.76 734.65 229.87 734.37 229.87 C 734.09 229.87 733.81 229.76 733.59 229.55 C 729.35 225.34 719.69 225.34 715.45 229.55 C 715.02 229.98 714.33 229.98 713.9 229.55 Z M 752.93 219.01 C 752.93 217.99 752.53 217.04 751.81 216.32 C 751.07 215.58 750.09 215.21 749.11 215.21 C 748.13 215.21 747.16 215.58 746.41 216.32 C 744.92 217.8 744.92 220.21 746.41 221.69 C 747.9 223.17 750.32 223.17 751.81 221.69 C 752.53 220.97 752.93 220.02 752.93 219.01 Z M 753.36 223.22 C 752.19 224.39 750.65 224.97 749.11 224.97 C 747.57 224.97 746.04 224.39 744.86 223.22 C 742.52 220.9 742.52 217.11 744.86 214.79 C 747.21 212.46 751.02 212.46 753.36 214.79 C 755.7 217.11 755.7 220.9 753.36 223.22 Z M 703.7 219.03 C 703.7 218.02 703.31 217.06 702.58 216.35 C 701.86 215.63 700.91 215.24 699.89 215.24 C 698.87 215.24 697.91 215.63 697.19 216.35 C 696.47 217.06 696.07 218.02 696.07 219.03 C 696.07 220.04 696.47 220.99 697.19 221.71 C 698.63 223.14 701.14 223.14 702.58 221.71 C 703.31 220.99 703.7 220.04 703.7 219.03 Z M 704.13 223.25 C 702.96 224.41 701.42 224.99 699.89 224.99 C 698.35 224.99 696.81 224.41 695.64 223.25 C 693.3 220.92 693.3 217.14 695.64 214.81 C 697.98 212.48 701.79 212.48 704.13 214.81 C 706.47 217.14 706.47 220.92 704.13 223.25 Z M 740.79 235.24 C 736.42 239.58 730.61 241.97 724.43 241.97 C 718.25 241.97 712.45 239.58 708.08 235.24 C 705.08 232.27 703.43 228.71 702.58 226.25 L 700.51 226.97 C 701.44 229.64 703.24 233.51 706.53 236.78 C 711.31 241.53 717.67 244.15 724.43 244.15 C 731.2 244.15 737.55 241.53 742.33 236.78 C 745.1 234.04 747.3 230.55 748.53 226.96 L 746.46 226.26 C 745.33 229.54 743.32 232.73 740.79 235.24 Z M 702.58 211.75 L 700.51 211.03 C 701.84 207.25 703.98 203.76 706.54 201.21 C 711.32 196.47 717.67 193.85 724.43 193.85 C 731.19 193.85 737.55 196.47 742.33 201.21 C 745.02 203.89 747.29 207.47 748.53 211.03 L 746.46 211.75 C 745.32 208.49 743.25 205.21 740.78 202.75 C 736.42 198.41 730.61 196.03 724.43 196.03 C 718.26 196.03 712.45 198.41 708.09 202.75 C 705.75 205.07 703.8 208.27 702.58 211.75 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 725
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "SQS")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 725,
    y: 278,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "SQS")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 944 160 L 944 40 L 290.5 40 L 290.5 153.63",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 290.5 158.88 L 287 151.88 L 290.5 153.63 L 294 151.88 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 56,
      marginLeft: 595
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Read log files and parse")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 595,
    y: 59,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Read log files and parse")))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 905.5 180 L 983.5 180 L 983.5 258 L 905.5 258 Z",
    fill: "url(#mx-gradient-f78e04-1-d05c17-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 931.17 247.97 L 917.33 247.97 L 932.63 215.99 L 939.56 230.26 Z M 933.63 212.93 C 933.44 212.55 933.05 212.3 932.63 212.3 L 932.62 212.3 C 932.19 212.3 931.8 212.55 931.62 212.94 L 914.55 248.61 C 914.39 248.95 914.41 249.36 914.61 249.68 C 914.82 250 915.18 250.2 915.56 250.2 L 931.87 250.2 C 932.3 250.2 932.7 249.95 932.88 249.56 L 941.81 230.73 C 941.96 230.43 941.96 230.07 941.81 229.77 Z M 972.38 247.97 L 958.63 247.97 L 936.58 201.81 C 936.4 201.42 936 201.17 935.57 201.17 L 926.58 201.17 L 926.59 190.03 L 944.22 190.03 L 966.17 236.19 C 966.35 236.58 966.75 236.83 967.18 236.83 L 972.38 236.83 Z M 973.5 234.6 L 967.88 234.6 L 945.93 188.44 C 945.75 188.05 945.35 187.8 944.92 187.8 L 925.47 187.8 C 924.86 187.8 924.36 188.3 924.35 188.91 L 924.34 202.28 C 924.34 202.58 924.46 202.86 924.67 203.07 C 924.88 203.28 925.16 203.4 925.46 203.4 L 934.87 203.4 L 956.92 249.56 C 957.11 249.95 957.5 250.2 957.93 250.2 L 973.5 250.2 C 974.11 250.2 974.61 249.7 974.61 249.09 L 974.61 235.71 C 974.61 235.1 974.11 234.6 973.5 234.6 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 945
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "AWS Lambda", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 13
    }
  }), "(Log processor)")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 945,
    y: 278,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "AWS Lambda...")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 775.5 220 L 889.13 220",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 894.38 220 L 887.38 223.5 L 889.13 220 L 887.38 216.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 241,
      marginLeft: 831
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Trigger")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 831,
    y: 244,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Trigger")))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 830.5,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 817
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "4"))))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 831,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "4")))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 505.5,
    cy: 15,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 15,
      marginLeft: 492
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "5"))))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 19,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "5")))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 1145.5 180 L 1223.5 180 L 1223.5 258 L 1145.5 258 Z",
    fill: "url(#mx-gradient-945df2-1-5a30b5-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 1165.91 206.39 L 1154.45 206.39 C 1153.81 206.39 1153.3 206.9 1153.3 207.53 L 1153.3 248.81 C 1153.3 249.45 1153.81 249.96 1154.45 249.96 L 1165.91 249.96 C 1166.55 249.96 1167.06 249.45 1167.06 248.81 L 1167.06 207.53 C 1167.06 206.9 1166.55 206.39 1165.91 206.39 Z M 1155.59 247.67 L 1155.59 208.68 L 1164.77 208.68 L 1164.77 247.67 Z M 1171.65 214.41 L 1169.35 214.41 L 1169.35 199.51 C 1169.35 198.87 1169.87 198.36 1170.5 198.36 L 1181.97 198.36 C 1182.6 198.36 1183.11 198.87 1183.11 199.51 L 1183.11 204.09 L 1180.82 204.09 L 1180.82 200.65 L 1171.65 200.65 Z M 1180.82 240.79 L 1183.11 240.79 L 1183.11 248.81 C 1183.11 249.45 1182.6 249.96 1181.97 249.96 L 1170.5 249.96 C 1169.87 249.96 1169.35 249.45 1169.35 248.81 L 1169.35 231.61 L 1171.65 231.61 L 1171.65 247.67 L 1180.82 247.67 Z M 1187.7 202.95 L 1185.41 202.95 L 1185.41 189.19 C 1185.41 188.55 1185.92 188.04 1186.55 188.04 L 1198.02 188.04 C 1198.65 188.04 1199.17 188.55 1199.17 189.19 L 1199.17 205.24 L 1196.87 205.24 L 1196.87 190.33 L 1187.7 190.33 Z M 1196.87 243.08 L 1199.17 243.08 L 1199.17 248.81 C 1199.17 249.45 1198.65 249.96 1198.02 249.96 L 1186.55 249.96 C 1185.92 249.96 1185.41 249.45 1185.41 248.81 L 1185.41 241.93 L 1187.7 241.93 L 1187.7 247.67 L 1196.87 247.67 Z M 1215.22 196.07 L 1215.22 235.05 L 1212.93 235.05 L 1212.93 197.21 L 1203.75 197.21 L 1203.75 209.83 L 1201.46 209.83 L 1201.46 196.07 C 1201.46 195.43 1201.97 194.92 1202.61 194.92 L 1214.07 194.92 C 1214.71 194.92 1215.22 195.43 1215.22 196.07 Z M 1203.82 229.93 C 1204.88 227.78 1205.48 225.36 1205.48 222.81 C 1205.48 213.8 1198.15 206.47 1189.14 206.47 C 1180.13 206.47 1172.81 213.8 1172.81 222.81 C 1172.81 231.82 1180.13 239.15 1189.14 239.15 C 1192.47 239.15 1195.56 238.14 1198.14 236.43 L 1208.01 245.33 C 1208.83 246.07 1209.87 246.44 1210.9 246.43 C 1212.08 246.43 1213.26 245.96 1214.11 245.01 C 1215.7 243.24 1215.56 240.51 1213.79 238.91 Z M 1175.1 222.81 C 1175.1 215.06 1181.4 208.76 1189.14 208.76 C 1196.89 208.76 1203.19 215.06 1203.19 222.81 C 1203.19 230.55 1196.89 236.85 1189.14 236.85 C 1181.4 236.85 1175.1 230.55 1175.1 222.81 Z M 1212.41 243.48 C 1211.66 244.3 1210.38 244.37 1209.54 243.63 L 1199.98 235 C 1200.99 234.1 1201.9 233.09 1202.66 231.97 L 1212.26 240.62 C 1213.08 241.36 1213.15 242.65 1212.41 243.48 Z M 1189.14 211.33 C 1182.81 211.33 1177.67 216.48 1177.67 222.81 C 1177.67 229.14 1182.81 234.28 1189.14 234.28 C 1195.47 234.28 1200.62 229.14 1200.62 222.81 C 1200.62 216.48 1195.47 211.33 1189.14 211.33 Z M 1189.14 231.99 C 1184.08 231.99 1179.96 227.87 1179.96 222.81 C 1179.96 217.74 1184.08 213.62 1189.14 213.62 C 1194.21 213.62 1198.33 217.74 1198.33 222.81 C 1198.33 227.87 1194.21 231.99 1189.14 231.99 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 265,
      marginLeft: 1185
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon OpenSearch Service")))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1185,
    y: 278,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Amazon OpenS...")))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 1005.5 218.71 L 1119.13 218.71",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 1124.38 218.71 L 1117.38 222.21 L 1119.13 218.71 L 1117.38 215.21 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 239,
      marginLeft: 1061
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Upload parsed logs")))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1061,
    y: 243,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Upload parsed logs")))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1060.5,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 1047
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "6"))))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1061,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "6")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 1145.5 350 L 1223.5 350 L 1223.5 428 L 1145.5 428 Z",
    fill: "url(#mx-gradient-60a337-1-277116-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 1207.78 392.22 L 1208.21 389.21 C 1212.16 391.57 1212.21 392.55 1212.21 392.58 C 1212.2 392.58 1211.53 393.14 1207.78 392.22 Z M 1205.62 391.62 C 1198.8 389.56 1189.3 385.2 1185.46 383.39 C 1185.46 383.37 1185.46 383.36 1185.46 383.34 C 1185.46 381.86 1184.26 380.66 1182.78 380.66 C 1181.31 380.66 1180.11 381.86 1180.11 383.34 C 1180.11 384.82 1181.31 386.02 1182.78 386.02 C 1183.43 386.02 1184.02 385.78 1184.48 385.39 C 1189.01 387.53 1198.43 391.82 1205.3 393.85 L 1202.58 413.03 C 1202.57 413.08 1202.57 413.13 1202.57 413.18 C 1202.57 414.87 1195.1 417.97 1182.89 417.97 C 1170.55 417.97 1162.99 414.87 1162.99 413.18 C 1162.99 413.13 1162.99 413.08 1162.98 413.03 L 1157.31 371.57 C 1162.22 374.95 1172.79 376.74 1182.89 376.74 C 1192.98 376.74 1203.53 374.96 1208.46 371.59 Z M 1156.71 367.25 C 1156.79 365.78 1165.21 360.03 1182.89 360.03 C 1200.57 360.03 1209 365.78 1209.08 367.25 L 1209.08 367.75 C 1208.11 371.04 1197.19 374.51 1182.89 374.51 C 1168.57 374.51 1157.65 371.02 1156.71 367.73 Z M 1211.31 367.27 C 1211.31 363.41 1200.24 357.8 1182.89 357.8 C 1165.55 357.8 1154.48 363.41 1154.48 367.27 L 1154.58 368.11 L 1160.77 413.27 C 1160.91 418.32 1174.38 420.2 1182.89 420.2 C 1193.44 420.2 1204.65 417.77 1204.8 413.27 L 1207.47 394.44 C 1208.95 394.8 1210.18 394.98 1211.16 394.98 C 1212.48 394.98 1213.37 394.66 1213.91 394.01 C 1214.35 393.49 1214.52 392.85 1214.39 392.16 C 1214.11 390.62 1212.27 388.96 1208.55 386.83 L 1211.19 368.16 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 435,
      marginLeft: 1185
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon S3", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 13
    }
  }), "(Failed log bucket)")))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1185,
    y: 448,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Amazon S3...")))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 935.5 310 L 935.5 390 L 1119.13 390",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 1124.38 390 L 1117.38 393.5 L 1119.13 390 L 1117.38 386.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 411,
      marginLeft: 1061
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Write failed logs")))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1061,
    y: 414,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Write failed logs")))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1060.5,
    cy: 365,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 365,
      marginLeft: 1047
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "7"))))), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 1061,
    y: 369,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "7")))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 170,
    width: 64,
    height: 78,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 55.52 221.63 L 81.88 221.63 L 81.88 218.08 L 55.52 218.08 Z M 55.52 210.77 L 88.08 210.77 L 88.08 207.23 L 55.52 207.23 Z M 55.52 199.92 L 69.48 199.92 L 69.48 196.38 L 55.52 196.38 Z M 34.05 232.03 L 35.37 232.03 L 35.37 235.58 L 32.27 235.58 C 31.29 235.58 30.5 234.78 30.5 233.8 L 30.5 171.8 C 30.5 170.82 31.29 170.02 32.27 170.02 L 61.73 170.02 L 61.73 173.57 L 34.05 173.57 Z M 43.35 238.23 L 46.22 238.23 L 46.22 241.78 L 41.57 241.78 C 40.59 241.78 39.8 240.98 39.8 240 L 39.8 178 C 39.8 177.02 40.59 176.22 41.57 176.22 L 69.48 176.22 L 69.48 179.77 L 43.35 179.77 Z M 52.65 244.43 L 52.65 185.97 L 75.45 185.97 L 75.45 199.7 C 75.45 200.68 76.25 201.47 77.23 201.47 L 90.95 201.47 L 90.95 244.43 Z M 79 188.48 L 88.45 197.92 L 79 197.92 Z M 93.98 198.44 L 78.48 182.94 C 78.15 182.61 77.7 182.42 77.23 182.42 L 50.87 182.42 C 49.9 182.42 49.1 183.22 49.1 184.2 L 49.1 246.2 C 49.1 247.18 49.9 247.98 50.87 247.98 L 92.73 247.98 C 93.71 247.98 94.5 247.18 94.5 246.2 L 94.5 199.7 C 94.5 199.23 94.31 198.78 93.98 198.44 Z",
    fill: "#232f3d",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 255,
      marginLeft: 63
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Source", /*#__PURE__*/React.createElement("br", {
    style: {
      fontSize: 13
    }
  }), "(Log files)")))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 63,
    y: 268,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Source...")))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 494 181 L 572 181 L 572 259 L 494 259 Z",
    fill: "url(#mx-gradient-f78e04-1-d05c17-1-s-0)",
    stroke: "none",
    pointerEvents: "all"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 558.71 228.49 L 549.95 223.23 L 549.95 210.73 C 549.95 210.34 549.75 209.98 549.41 209.78 L 536.83 202.44 L 536.83 191.86 L 558.71 204.79 Z M 560.36 203.22 L 536.29 189 C 535.95 188.8 535.54 188.8 535.19 188.99 C 534.85 189.19 534.64 189.55 534.64 189.94 L 534.64 203.07 C 534.64 203.46 534.85 203.82 535.18 204.02 L 547.77 211.36 L 547.77 223.85 C 547.77 224.24 547.97 224.59 548.3 224.79 L 559.24 231.35 C 559.41 231.46 559.6 231.51 559.8 231.51 C 559.99 231.51 560.17 231.46 560.34 231.37 C 560.68 231.17 560.89 230.81 560.89 230.42 L 560.89 204.16 C 560.89 203.78 560.69 203.42 560.36 203.22 Z M 532.94 248.86 L 507.29 235.23 L 507.29 204.79 L 529.17 191.86 L 529.17 202.47 L 517.65 209.8 C 517.33 210.01 517.14 210.35 517.14 210.73 L 517.14 229.32 C 517.14 229.73 517.37 230.11 517.73 230.29 L 532.44 237.95 C 532.76 238.11 533.14 238.12 533.45 237.95 L 547.73 230.57 L 556.51 235.85 Z M 559.27 234.95 L 548.33 228.38 C 548 228.19 547.6 228.18 547.26 228.35 L 532.95 235.75 L 519.33 228.66 L 519.33 211.33 L 530.85 203.99 C 531.17 203.79 531.36 203.44 531.36 203.07 L 531.36 189.94 C 531.36 189.55 531.15 189.19 530.81 188.99 C 530.47 188.8 530.05 188.8 529.71 189 L 505.64 203.22 C 505.31 203.42 505.11 203.78 505.11 204.16 L 505.11 235.89 C 505.11 236.29 505.33 236.66 505.69 236.85 L 532.44 251.07 C 532.6 251.16 532.77 251.2 532.95 251.2 C 533.13 251.2 533.31 251.15 533.48 251.06 L 559.23 236.84 C 559.58 236.65 559.79 236.3 559.8 235.91 C 559.81 235.51 559.6 235.15 559.27 234.95 Z",
    fill: "#ffffff",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe flex-start",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 266,
      marginLeft: 533
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: #232F3E; ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(35, 47, 62)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "nowrap"
    }
  }, "Amazon ECS")))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 533,
    y: 279,
    fill: "#232F3E",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Amazon ECS")))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 484 220 L 340.37 220",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 335.12 220 L 342.12 216.5 L 340.37 220 L 342.12 223.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 241,
      marginLeft: 405
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Iterate log files")))), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 405,
    y: 244,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Iterate log files")))), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 409,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 395
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "2"))))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 409,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "2")))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 584 220 L 667.63 220",
    fill: "none",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 672.88 220 L 665.88 223.5 L 667.63 220 L 665.88 216.5 Z",
    fill: "rgb(0, 0, 0)",
    stroke: "rgb(0, 0, 0)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 1,
      height: 1,
      paddingTop: 240,
      marginLeft: 626
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      backgroundColor: "rgb(255, 255, 255)",
      whiteSpace: "nowrap"
    }
  }, "Write log location")))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 626,
    y: 243,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle"
  }, "Write log location")))), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 634,
    cy: 185,
    rx: 15,
    ry: 15,
    fill: "#000000",
    stroke: "rgb(0, 0, 0)",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 28,
      height: 1,
      paddingTop: 185,
      marginLeft: 620
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgb(0, 0, 0); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 13,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      fontWeight: "bold",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, /*#__PURE__*/React.createElement("font", {
    style: {
      fontSize: 13
    },
    color: "#ffffff"
  }, "3"))))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 634,
    y: 189,
    fill: "rgb(0, 0, 0)",
    fontFamily: "Helvetica",
    fontSize: "13px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "3"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Text is not SVG - cannot display")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3SourceOneTime);
export default __webpack_public_path__ + "static/media/s3-source-one-time.4176c67df25c7ddb5a4c486517743413.svg";
export { ForwardRef as ReactComponent };